import apiClient from "../../../../../services/apiClient";


export const kindergartenAPI = {
  addKindergarten: async (data) => {

    const ret = await apiClient.post( 'kindergartens' ,data);

    if(ret.data) return { success: true, data: ret.data };
    
    if (ret.error) return { success: false, error: ret.error };
        
  }
};